
import { Beneficio } from "./Beneficio.model";
import { VariablesGlobales } from "./variablesGlobales.model";

export class Plan {
    id_planes:              number = -1;
    nombre:                 string = '';
    descripcion:            string = '';
    precio:                 number = 0;
    descuento:              number = 0;
    fecha_inicio_descuento: Date = new Date();
    fecha_fin_descuento:    Date = new Date();
    estado:                 number = 0;
    beneficios:             Beneficio[] | null = [];

    /**
     * Obtener trama para obtener los planes.
     * @returns - Trama para obtener los planes.
     */
    public static planes(){
        const req = VariablesGlobales._getBody("C11", 356);
        req["data"]['anidar_beneficios'] = 1,
        req["data"]['id_planes'] = -1,
        req["data"]['estado'] = -1,
        req["data"]['anidar_productos'] = 0
        return req;
    }

    /**
     * Obtener trama para obtener los planes.
     * @returns - Trama para obtener los planes.
     */
    public static planById(id:number){
        const req = VariablesGlobales._getBody("C11", 356);
        req["data"]['anidar_beneficios'] = 1,
        req["data"]['id_planes'] = id,
        req["data"]['estado'] = 1,
        req["data"]['anidar_productos'] = 1
        return req;
    }

}